import { Dropdown, Button } from "react-bootstrap";
import cx from 'classnames';
import { REPORT_TYPES } from '../constants/reports';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { changeReportType } from 'actions/storyboardReports';
import styles from '../report.module.scss'
import { useReportType } from '../ReportsProvider';

const OverAllFilterHeader = () => {
  return (
    <span className={styles.filterHeader}>
      <span className={styles.left}>
        <h3 className={styles.title}>Filter By</h3>
        <span className={styles.subTitle}>You can filter by overall, personlized and campaign reports</span>
      </span>
      <span className={styles.right}>
        <ReportsCategoryDropdown />
      </span>
    </span>
  );
};

const ReportsCategoryDropdown = () => {
  const { reportType } = useReportType()
  const dispatch = useDispatch()

  return (
    <Dropdown className={styles.filterDropdown}>
      <Dropdown.Toggle className={styles.selected}>
        <Button size='sm' variant='primary' className={styles.button}>
          <span className={styles.filterType}>
            {REPORT_TYPES[reportType].label}
          </span>
          <i className={cx(styles.icon, 'cleverstory-drop-down')} />
        </Button>
      </Dropdown.Toggle>
      <Dropdown.Menu className={styles.typesMenu}>
        {Object.values(REPORT_TYPES).map(({ label, value }, index) => (
          <Dropdown.Item
            key={index}
            className={cx({ active: value === reportType })}
            onClick={() => dispatch(changeReportType(value))}
          >
            {label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default OverAllFilterHeader;